import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '~/components/Button';
import { SETTINGS_ROUTES } from '~settings//config/routes';
import type { UserListItem } from '~settings/api/lib/schemas';
import type { UserListQueryVariables } from '~settings/api/queries/userList';
import { useUserList } from '~settings/api/queries/userList';
import { ListControls } from '~settings/components/ListControls';
import { Table } from '~settings/components/Table';
import { usePagination } from '~settings/hooks/usePagination';

import { useUsersColumns } from './hooks/useUsersColumns';

const userEmptyArray: UserListItem[] = [];
const TEMP_HARDCODED_VARIABLES: UserListQueryVariables = {
  skip: 0,
  take: 50,
};

export const ListUserPage = () => {
  const { page, handlePageChange, perPage } = usePagination();
  const { isLoading, isError, userList } = useUserList(
    TEMP_HARDCODED_VARIABLES,
  );
  const columns = useUsersColumns();
  const { t } = useTranslation('settings', { keyPrefix: 'user' });
  const navigate = useNavigate();

  const [activeOption, setActiveOption] = useState<boolean | null>(null);

  const onClick = (row: UserListItem) => {
    navigate(SETTINGS_ROUTES.USER_DETAIL(row.id));
  };

  if (isLoading) {
    return <section className="py-md">Loading...</section>;
  }

  if (isError) {
    // eslint-disable-next-line i18next/no-literal-string
    return <section className="py-md">Something went wrong.</section>;
  }

  return (
    <>
      <ListControls
        placeholder={t('user.search')}
        options={['Internal', 'External']}
        filterType={'userType'}
        activeOption={activeOption}
        setActiveOption={setActiveOption}
        total={userList?.total ?? 0}
        page={page}
        perPage={perPage}
        entity="users"
        handlePageChange={handlePageChange}
        toolbarRightAddon={
          <Button
            asChild
            variant="primary"
            className="shrink-0 self-center"
            size="large"
          >
            <Link to={SETTINGS_ROUTES.USER_CREATE}>{t('addLink')}</Link>
          </Button>
        }
      />
      <Table
        data={userList?.data ?? userEmptyArray}
        columns={columns}
        onRowClick={onClick}
      />
    </>
  );
};
ListUserPage.displayName = 'ListUserPage';
